// extracted by mini-css-extract-plugin
module.exports = {"container":"_9e349ee7","value":"_7eb063cb","closeIconWrapper":"_ffff0d0e"};